import sentry from 'common/helpers/analytics/sentry'


export const checkIsEmpty = (value: any): boolean => (
  value === undefined
  || value === null
  || value === ''
)

interface ICheckEmptyParams {
  object: { [key: string]: any },
  ignoreParams?: string[],
  place?: string,
  sendError?: boolean
}

const checkEmptyParams = ({ object, ignoreParams = [], place, sendError }: ICheckEmptyParams): string[] => {
  const emptyParams = []

  Object.keys(object).forEach((key) => {
    const value = object[key]

    if (ignoreParams.includes(key)) {
      return
    }

    if (checkIsEmpty(value)) {
      emptyParams.push(key)
    }
  })

  if (emptyParams.length && sendError) {
    sentry.captureException(`${place} empty params`, {
      extra: {
        emptyParams,
        object,
      },
    })
  }

  return emptyParams
}


export default checkEmptyParams
